import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  eventListing: {
    loading: false,
    error: null,
    data: null,
  },
  eventDetails: {
    loading: false,
    error: null,
    data: null,
  },
  leakAlerts: {
    loading: false,
    error: null,
    data: null,
  },
  createEvent: {
    loading: false,
    error: null,
    data: null,
  },
  acknowledgeAlert: {
    loading: false,
    error: null,
    data: null,
  },
};

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    // Event Listing
    eventListingStart: (state) => {
      state.eventListing.loading = true;
      state.eventListing.error = null;
    },
    eventListingSuccess: (state, action) => {
      state.eventListing.loading = false;
      state.eventListing.data = action.payload;
      state.eventListing.error = null;
    },
    eventListingFailure: (state, action) => {
      state.eventListing.loading = false;
      state.eventListing.error = action.payload;
    },
    eventListingReset: (state) => {
      state.eventListing = initialState.eventListing;
    },

    // Event Details
    eventDetailsStart: (state) => {
      state.eventDetails.loading = true;
      state.eventDetails.error = null;
    },
    eventDetailsSuccess: (state, action) => {
      state.eventDetails.loading = false;
      state.eventDetails.data = action.payload;
      state.eventDetails.error = null;
    },
    eventDetailsFailure: (state, action) => {
      state.eventDetails.loading = false;
      state.eventDetails.error = action.payload;
    },

    // Leak Alerts
    leakAlertsStart: (state) => {
      state.leakAlerts.loading = true;
      state.leakAlerts.error = null;
    },
    leakAlertsSuccess: (state, action) => {
      state.leakAlerts.loading = false;
      state.leakAlerts.data = action.payload;
      state.leakAlerts.error = null;
    },
    leakAlertsFailure: (state, action) => {
      state.leakAlerts.loading = false;
      state.leakAlerts.error = action.payload;
    },

    // Create Event
    createEventStart: (state) => {
      state.createEvent.loading = true;
      state.createEvent.error = null;
      state.createEvent.data = null;
    },
    createEventSuccess: (state, action) => {
      state.createEvent.loading = false;
      state.createEvent.data = action.payload;
      state.createEvent.error = null;
    },
    createEventFailure: (state, action) => {
      state.createEvent.loading = false;
      state.createEvent.error = action.payload;
    },
    createEventReset: (state) => {
      state.createEvent = initialState.createEvent;
    },

    // Acknowledge Alert
    acknowledgeAlertStart: (state) => {
      state.acknowledgeAlert.loading = true;
      state.acknowledgeAlert.error = null;
      state.acknowledgeAlert.data = null;
    },
    acknowledgeAlertSuccess: (state, action) => {
      state.acknowledgeAlert.loading = false;
      state.acknowledgeAlert.data = action.payload;
      state.acknowledgeAlert.error = null;
    },
    acknowledgeAlertFailure: (state, action) => {
      state.acknowledgeAlert.loading = false;
      state.acknowledgeAlert.error = action.payload;
    },
    acknowledgeAlertReset: (state) => {
      state.acknowledgeAlert = initialState.acknowledgeAlert;
    },
  },
});

export const {
  eventListingStart,
  eventListingSuccess,
  eventListingFailure,
  eventListingReset,
  eventDetailsStart,
  eventDetailsSuccess,
  eventDetailsFailure,
  leakAlertsStart,
  leakAlertsSuccess,
  leakAlertsFailure,
  createEventStart,
  createEventSuccess,
  createEventFailure,
  createEventReset,
  acknowledgeAlertStart,
  acknowledgeAlertSuccess,
  acknowledgeAlertFailure,
  acknowledgeAlertReset,
} = inventorySlice.actions;

export default inventorySlice.reducer;
